import React, { Component } from 'react'

class CharacterDropIn extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        let _value = null
        if (typeof this.props.value == 'undefined' ) return <div />
        if (typeof this.props.value == 'string') _value = this.props.value.split('') 
        if (typeof this.props.value == 'object') {
            _value = Object.keys(this.props.value).length.toString().split('')
        }
        let _rendered = _value.map( function(x,i) {
            if (x == ' ') {
                return (
                    <span style={{paddingLeft:'2px',paddingRight:'2px'}} key={i}>{x}</span>
                )
            }
            return (
                <span key={i}>{x}</span>
            )
        })

        return (
            <div className='characterdropin'>
                {_rendered}
            </div>
        )
    }
}

export default CharacterDropIn



// WEBPACK FOOTER //
// ./src/components/CharacterDropIn.js